import React, {DragEvent, useCallback} from "react";
import CssBaseline from "@mui/material/CssBaseline";
import {AuthProvider} from "@/app/auth/AuthContext";
import {ThemeProvider} from "@/app/AppThemeContext";
import {I18nextProvider} from "react-i18next";
import i18n from "@/i18n";
import {LocaleProvider} from "@/app/locale/LocaleProvider";
import {SnackbarProvider} from "notistack";
import {AppRoutes} from "@/app/AppRoutes";
import {FeedbackDialogProvider} from "@/pages/login-page/feedback/FeedbackDialogProvider";

export const App = () => {
    const handleDragOver = useCallback((e: DragEvent<HTMLSpanElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer) {
            e.dataTransfer.dropEffect = "none";
        }
    }, []);
    return (
        <I18nextProvider i18n={i18n}>
            <ThemeProvider>
                <CssBaseline />
                <AuthProvider>
                    <span onDragOver={handleDragOver}>
                        <LocaleProvider i18n={i18n}>
                            <SnackbarProvider maxSnack={6}>
                                <FeedbackDialogProvider>
                                    <AppRoutes />
                                </FeedbackDialogProvider>
                            </SnackbarProvider>
                        </LocaleProvider>
                    </span>
                </AuthProvider>
            </ThemeProvider>
        </I18nextProvider>
    );
};
